<template>
    <div class="login__wrapper">
        <div class="grid__picture">
            <picture>
                <source media="(min-width: 1025px)"
                        srcset="/images/new-background-auth.jpg"
                        type="image/jpeg">
                <source media="(min-width: 320px)"
                        srcset="/images/new-background-auth-768.jpg"
                        type="image/jpeg">
                <img src="/images/new-background-auth.jpg"
                     alt="">
            </picture>
        </div>
        <div class="login__container">
            <LoginForm />
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';

import Utils from '@/helpers/Utils';

import LoginForm from '@/components/Forms/Login/Login';
import {redirectAfterAuth} from '@/helpers/authRedirect';

export default {
    name: 'Login',

    components: {
        LoginForm
    },

    computed: {
        ...mapGetters({
            isAuth: 'GET_IS_AUTHENTICATED'
        }),
    },

    async created() {
        if (this.isAuth) {
            await redirectAfterAuth(this.$router, this.$store, '/appointments');

            return;
        }


        await this.createCSRFToken();
    },

    methods: {
        ...mapActions(['createCSRFToken'])
    }
};
</script>
